export default (state = {
  coordinates: 'decimal',
  units: 'imperial',
  friendLocations: false,
  selectedTopo: 18
}, { type, payload }) => {
  switch (type) {
    case 'USER_PREFERENCES_SET':
      return Object.assign({}, state, payload)
    case 'USER_PREFERENCES_RESET':
      return {
        coordinates: 'decimal',
        units: 'imperial',
        friendLocations: false,
        selectedTopo: 18
      }
    case 'LOGOUT':
      return {
        coordinates: 'decimal',
        units: 'imperial',
        friendLocations: false,
        selectedTopo: 18
      }
    default:
      return state
  }
}